
































































import OSS from "ali-oss";
import { getOSSConfig } from "@/api/ossImageUploader";
import ImgCutter from "vue-img-cutter";
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
@Component({
  components: {
    ImgCutter,
  },
})
export default class extends Vue {
  @Prop() originUrl?: string;
  @Prop() originName?: string;
  @Prop() studentId?: string;
  previewUrl: string = ""; // 裁切器展示图片
  previewBlob: string = ""; // 裁切器展示图片Blob，用于上传
  editDialogVisible: boolean = false;
  previewImageName: string = ""; // 截图名称
  client = null;
  prefix = "";
  cdn_url = "";
  callback = {};
  imageCache = {
    name: "",
    src: "",
  };
  @Watch("originUrl")
  onOriginUrlChange(n: any) {
    this.previewUrl = n;
  }
  mounted() {
    this.previewUrl = this.originUrl || "";
  }
  openEditDialog() {
    const self = this as any;
    this.editDialogVisible = true;
    self.$nextTick(() => {
      self.$refs.imgCutterRef.handleOpen({
        name: self.originName,
        src: self.originUrl,
      });
    });
  }
  onChooseImg(file: any) {
    const self = this as any;
    if (file.size) {
      // 本地文件触发
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e: any) {
        self.imageCache = {
          name: file.name,
          src: e.target.result,
        };
      };
    } else {
      // 拍照触发
      self.imageCache = file;
    }
  }
  onPrintImg(e: any) {
    this.previewUrl = e.dataURL;
  }
  cutDown(res: any) {
    this.previewImageName = res.fileName;
    this.previewUrl = res.dataURL;
    this.previewBlob = res.blob;
    // 输出数据
    this.imageSubmit();
  }
  openCamera() {
    let url = window.location.origin + "/#/info_collect";
    if (this.studentId) {
      url = url + "?id=" + this.studentId;
    }
    window.open(url, "_blank");
    window.addEventListener("storage", this.onStorageChange);
  }
  onStorageChange(n: any) {
    const self = this as any;
    if (n.key === "studentCameraShootData") {
      const data = JSON.parse(n.newValue);
      self.$refs.imgCutterRef.handleOpen({
        name: data.name,
        src: data.url,
      });
    }
  }
  closeEditDialog() {
    this.previewImageName = "";
    this.previewUrl = this.originUrl || "";
    this.previewBlob = "";
    this.editDialogVisible = false;
  }
  imageUpload(cb: Function) {
    const self = this as any;
    getOSSConfig().then((res: any) => {
      if (res.error_code == 0) {
        self.prefix = res.data.object_name_prefix;
        self.cdn_url = res.data.cdn_url;
        self.callback = res.data.callback;
        self.client = new OSS({
          accessKeyId: res.data.access_key_id,
          accessKeySecret: res.data.access_key_secret,
          stsToken: res.data.security_token,
          region: "oss-cn-shenzhen",
          bucket: res.data.bucket,
        });
        self.client
          .put(self.prefix + self.previewImageName, self.previewBlob, {
            callback: {
              url: self.callback.callback_url,
              host: self.callback.callback_host,
              body: self.callback.callback_body,
              contentType: self.callback.callback_body_type,
            },
          })
          .then(function (result: any) {
            if (result.data.code == "Ok") {
              cb && cb(result.data.object);
            }
          })
          .catch(function (err: any) {
            self.$message({
              type: "warning",
              message: "照片上传失败",
            });
          });
      }
    });
  }
  imageSubmit() {
    const self = this as any;
    if (self.$refs.imgCutterRef.drawImg.img && !self.previewBlob) {
      // 上传了图片但是没裁剪
      self.$message({
        type: "warning",
        message: "请先裁剪图片",
      });
      return false;
    }
    if (this.previewImageName && this.previewBlob) {
      this.imageUpload((key: string) => {
        this.$emit("change", key);
        this.editDialogVisible = false;
      });
    } else {
      // 没传图没裁剪直接退出
      this.editDialogVisible = false;
    }
  }
  beforeDestroy() {
    window.removeEventListener("storage", this.onStorageChange);
  }
}
